import { Document } from './types.ts'

export const documentStatusLabels: Record<Document['status'], string> = {
  idle: 'In attesa',
  in_review: 'In review',
  processing: 'In elaborazione',
  ready: 'Pronto',
}
